module.exports = __webpack_public_path__ + "static/img/q3.3b8c7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q3.png
// module id = EJAZ
// module chunks = 0